import { ComponentType } from 'react';
import { Button, Icon, IconProps } from '@chakra-ui/react';
import { FaFacebook } from 'react-icons/fa';

export const FacebookOnboardingButton = () => {
  const handleLogin = () => {
    const authUrl =
      // 'https://www.facebook.com/v20.0/dialog/oauth?client_id=841689861857500&display=popup&redirect_uri=https%3A%2F%2Fwww.saleradius.com%2Forganization%2Finbox%2Ffacebook%2Fsuccess&response_type=code&scope=pages_messaging,pages_manage_metadata,pages_read_engagement,pages_show_list';
      'https://www.facebook.com/v20.0/dialog/oauth?client_id=841689861857500&display=popup&redirect_uri=https%3A%2F%2Fwww.saleradius.com%2Forganization%2Finbox%2Ffacebook%2Fsuccess&response_type=code&scope=pages_show_list,pages_manage_metadata,pages_read_engagement,pages_manage_posts,pages_manage_engagement,pages_messaging';
    window.location.href = authUrl;
  };

  return (
    <Button
      onClick={handleLogin}
      leftIcon={<Icon as={FaFacebook as ComponentType<IconProps>} />}
      size="lg"
      bgGradient="linear(to-r, #1877F2, #2d88ff)"
      _hover={{
        bgGradient: 'linear(to-r, #2d88ff, #1a6ae2)',
        transform: 'translateY(-2px)',
        boxShadow: 'md',
      }}
      color="white"
      w="full"
    >
      Connect Facebook Account
    </Button>
  );
};
